import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BaseSearchForm } from '@shared/ui/base-search-form';
import { UiGroupControl } from '@shared/ui/controls/ui-group-control.model';
import { ViewControl } from '@shared/ui/controls/view-control.model';
import { UiColumn } from '@shared/ui/ui-column';
import { ViewRowControl } from '@shared/ui/controls/view-row-control.model';
import { ToggleControl } from '../../../shared/ui/controls/toggle-control.model';
import { SearchGridComponent } from '../../../shared/components/grid/search-grid.component';
import { ToolBarComponent } from '@progress/kendo-angular-toolbar';
import { ToolbarItem } from '../../../shared/interfaces/tool-bar-item.interface';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../core/services/authentication.serivce';
import { AuthUserSearchResult } from '../../../shared/interfaces/gridrows/auth-user-search-result.interface';
import { TextControl } from '../../../shared/ui/controls/text-control.model';
import { Permission } from '../../../core/literals/permission.literal';

@Component({
    selector: 'app-auth-user-list',
    templateUrl: './auth-user-list.component.html',
    styleUrls: ['./auth-user-list.component.css'],
    standalone: false
})
export class AuthUserListComponent extends BaseSearchForm<AuthUserSearchResult> implements OnInit {

  @ViewChild(SearchGridComponent) grid: SearchGridComponent;
  @ViewChild('toolbar') bar: ToolBarComponent;

  organizationId: Number | null;

  @Input() items: ToolbarItem[];

  ngOnInit(): void {

    var session = this.auth.getSession();

    this.organizationId = Number(session?.organizationId);

    var toolbarAddNew: ToolbarItem = {
      text: 'Add User',
      icon: faPlus,
      hasMultiple: false,
      cssClass: 'success',
      action: () => { this.redirectToNewCustomer(); }
    };

    if (this.auth.canPerformAction(Permission.CreateUpdateUsers)) {
      this.toolbarItems.unshift(toolbarAddNew);
    }
  }
  constructor(private router: Router, private auth: AuthenticationService) {
    super();
    this.name = "User";
    this.apiController = "AuthUser";
    this.keyFieldName = "id";
    this.canFilterSearch = this.auth.isAdmin();

    this.initializeUiControls();
    this.setGridSettings();
  }
  override initializeUiControls() {
    const view = new ViewControl("");

    const search = new UiGroupControl("", "Search");

    const nameEmailFilter = new TextControl("nameEmailFilter", "User", "");
/*    const isActive = new ToggleControl("isActive", "Is Active?", true);*/

    var row = new ViewRowControl();
    row.controls.push(nameEmailFilter);

    search.rows.push(row);
    view.controls.push(search);

    this.views.push(view);
  }

    setGridSettings(): void {
      this.gridSettings = {
        gridName: "AuthUserSearch_Grid",
        showSubGrid: false,
        preloadData: true,
        columns: this.getColumns()
      };
    }

    private getColumns(): UiColumn[] {
      let cols: UiColumn[] = [];

      var name = new UiColumn("name", "User", 100);
      var email = new UiColumn("email", "Email", 150);
      var isActive = new UiColumn("isActive", "Is Active", 100, true, "boolean");

      cols.push(name, email, isActive);

      return cols;
    }

    public redirectToNewCustomer() {
      this.router.navigate(['/AuthUser/Detail/0']);
    }
}
